var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l1 = _vm.__map(_vm.supList, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var g0 = item.list.length
    var l0 =
      g0 > 0
        ? _vm.__map(item.list, function (sup_item, sup_index) {
            var $orig = _vm.__get_orig(sup_item)
            var g1 = item.list.length
            return {
              $orig: $orig,
              g1: g1,
            }
          })
        : null
    var g2 = g0 > 0 ? _vm.DataList.length == 0 && !_vm.loading : null
    return {
      $orig: $orig,
      g0: g0,
      l0: l0,
      g2: g2,
    }
  })
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l1: l1,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }